import {ComboBoxChangeEvent, ComboBoxFilterChangeEvent, ListItemProps} from "@progress/kendo-react-dropdowns"
import {Field} from "@progress/kendo-react-form"
import {useInternationalization} from "@progress/kendo-react-intl"
import React, {useEffect} from "react"
import {DealerTestPackage, setPlannerTestPackge} from "../../../containers/MotBooking/bookingSlice"
import {RootState} from "../../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../../store"
import BookingMultiColumnComboBox from "../../Shared/multiColumnComboBox"

const PlannerTestPackageCombo = () => {
    const dispatch = useAppDispatch()
    const intl = useInternationalization()
    const gettingTestPackages = useAppSelector(
        (state: RootState) => state.containers.motBooking.gettingPlannerTestPackages,
    )
    const dealerTestPackages = useAppSelector((state: RootState) => state.containers.motBooking.plannerTestPackages)
    const testPackageId = useAppSelector((state: RootState) => state.containers.motBooking.selectedPackagePlanner)

    const [testPackages, setTestPackages] = React.useState<DealerTestPackage[]>(dealerTestPackages)
    useEffect(() => {
        setTestPackages(dealerTestPackages)
    }, [dealerTestPackages, dispatch])

    const CurrencyFormatter = (value: number) => {
        return intl.formatNumber(value, "c")
    }

    const columns = [
        {
            field: "testPackageName",
            header: "Description",
            width: "550px",
        },
        {
            field: "duration",
            header: "Mins",
            width: "75px",
        },
        {
            field: "testFee",
            header: "Test Fee",
            width: "100px",
        },
        {
            field: "laneFee",
            header: "Lane fee",
            width: "100px",
        },
    ]
    let testPackageFormatted = testPackages.map(x => {
        return {
            ...x,
            testFee: CurrencyFormatter(x.testFee),
            laneFee: CurrencyFormatter(x.laneFee),
            testPackageDescription: x.testPackageDescription ?? "",
            testPackageName: `${x.testPackageName} ${
                x.testPackageDescription === null ? "" : `- ${x.testPackageDescription}`
            }`,
        }
    })

    const columnItemRender = (li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
        const children = columns.map((col, i) => {
            if (col.field === "testPackageName")
                return (
                    <span
                        title={`${itemProps.dataItem[col.field]}- ${
                            itemProps.dataItem["noofRecord"] > 1 && itemProps.dataItem["noofRepeat"] >= 1
                                ? "Multiple versions found for the selected week"
                                : ""
                        } `}
                        className={`k-table-td ${
                            !itemProps.dataItem["active"] ? "k-disabled c-not-allowed" : "c-pointer"
                        }`}
                        style={{
                            width: col.width,
                            borderRight: `${
                                itemProps.dataItem["noofRecord"] > 1 && itemProps.dataItem["noofRepeat"] >= 1
                                    ? "2px solid red"
                                    : ""
                            }`,
                        }}
                        key={"test_pack_desc_" + crypto.randomUUID()}
                    >
                        {itemProps.dataItem[col.field]}
                    </span>
                )
            if (col.field === "duration")
                return (
                    <span
                        className={`k-table-td ${
                            !itemProps.dataItem["active"] ? "k-disabled c-not-allowed" : "c-pointer"
                        }`}
                        style={{width: col.width}}
                        key={i}
                    >
                        {itemProps.dataItem[col.field]}
                    </span>
                )
            return (
                <span
                    className={`k-table-td ${
                        !itemProps.dataItem["active"] ? "k-disabled c-not-allowed" : "c-pointer"
                    }`}
                    style={{width: col.width}}
                    key={i}
                >
                    {itemProps.dataItem[col.field]}
                </span>
            )
        })

        return React.cloneElement(li, {...li.props}, children)
    }

    const onTestPackageSearch = (event: ComboBoxFilterChangeEvent) => {
        if (event) {
            // setFilter(event.filter)
            filterMultipleColumns(event.filter.value)
        }
    }

    const filterMultipleColumns = (searchText: string) => {
        if (searchText !== null && searchText.indexOf(" ") >= 0) {
            const words = searchText.split(" ")
            const data = dealerTestPackages.filter(x =>
                words.every(w =>
                    `${x.testPackageName} - ${x.testPackageDescription ?? ""}`
                        .toLocaleLowerCase()
                        .includes(w.toLocaleLowerCase()),
                ),
            )
            setTestPackages(data)
        } else if (searchText.length >= 3) {
            const data = dealerTestPackages.filter(
                x =>
                    x.testPackageDescription?.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()) ||
                    x.testPackageName?.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()),
            )
            setTestPackages(data)
        } else {
            setTestPackages(dealerTestPackages)
        }
    }

    const onTestPackageChange = (ev: ComboBoxChangeEvent) => {
        if (ev.value !== null) {
            const testPackage = ev.value as DealerTestPackage
            const data =
                dealerTestPackages.find(x => x.testPackageID === testPackage.testPackageID) || ({} as DealerTestPackage)
            dispatch(setPlannerTestPackge(data.testPackageID))
        } else {
            dispatch(setPlannerTestPackge(0))
        }
    }

    return (
        <Field
            allowCustom={false}
            name={"plannerTestPackageID"}
            component={BookingMultiColumnComboBox}
            value={testPackageId}
            textField="testPackageName"
            dataItemKey="testPackageID"
            data={testPackageFormatted}
            columns={columns}
            // label={"Test package"}
            itemRender={columnItemRender}
            filterable={true}
            loading={gettingTestPackages}
            onFilterChange={onTestPackageSearch}
            onChange={onTestPackageChange}
            placeholder={"Select test package"}
        />
    )
}
export default PlannerTestPackageCombo
